import voca from 'voca';

const listFormatter = new Intl.ListFormat('en-GB', {
  style: 'long',
  type: 'conjunction',
});

export function filtersListFormatter({
  filters,
  pluralRAMSName,
  translations,
}) {
  const list = Object.keys(filters).reduce((acc, filter) => {
    if (filters[filter])
      filter
        .split('And')
        .forEach((subFilter) =>
          acc.push(voca.lowerCase(translations[voca.lowerCase(subFilter)])),
        );

    return acc;
  }, []);

  return `${voca.capitalize(listFormatter.format(list))} ${pluralRAMSName}`;
}

export function filtersFormatter({
  filterCounts,
  filterDots,
  filters,
  translations,
}) {
  return Object.keys(filters).map((filter) => ({
    count: filterCounts[filter],
    dot: filterDots[filter],
    label: translations[filter],
    name: filter,
    value: filters[filter],
  }));
}
